export const nonNullable = <T extends Array<any>>(value: T): NonNullable<T[number]>[] => {
  return value.filter((item) => item !== null && item !== undefined) as NonNullable<T>;
};
